﻿(function() {
    "use strict";

    angular.module("app").controller("ItemsController", ItemsController);

    ItemsController.$inject = [];

    function ItemsController() {
        var vm = this;
    }
})();
